/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventConnectionStatusChangedFromJSON(json) {
    return StreemApiAnalyticEventConnectionStatusChangedFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventConnectionStatusChangedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roomSid': !exists(json, 'room_sid') ? undefined : json['room_sid'],
        'newStrength': !exists(json, 'new_strength') ? undefined : json['new_strength'],
        'method': !exists(json, 'method') ? undefined : json['method'],
    };
}
export function StreemApiAnalyticEventConnectionStatusChangedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room_sid': value.roomSid,
        'new_strength': value.newStrength,
        'method': value.method,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventConnectionStatusChangedMethod;
(function (StreemApiAnalyticEventConnectionStatusChangedMethod) {
    StreemApiAnalyticEventConnectionStatusChangedMethod["CELLULAR"] = "CONNECTION_METHOD_CELLULAR";
    StreemApiAnalyticEventConnectionStatusChangedMethod["INVALID"] = "CONNECTION_METHOD_INVALID";
    StreemApiAnalyticEventConnectionStatusChangedMethod["UNKNOWN"] = "CONNECTION_METHOD_UNKNOWN";
    StreemApiAnalyticEventConnectionStatusChangedMethod["WIFI"] = "CONNECTION_METHOD_WIFI";
})(StreemApiAnalyticEventConnectionStatusChangedMethod || (StreemApiAnalyticEventConnectionStatusChangedMethod = {}));
//# sourceMappingURL=StreemApiAnalyticEventConnectionStatusChanged.js.map